// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-line[data-v-9449be7e] {\n  margin-top: 10px;\n}\n.input-container[data-v-9449be7e] {\n  position: relative;\n}\n.remove-field[data-v-9449be7e] {\n  position: absolute;\n  right: 1em;\n  top: calc(50% - iconSize / 2);\n  cursor: pointer;\n  display: flex;\n}\n.remove-field.disabled[data-v-9449be7e] {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
